export const PLAN_PART_ONETIME = 'tx'
export const PLAN_PART_TRIAL = 't0'
export const PLAN_PART_MONTHLY_2 = 't2'
export const PLAN_PART_MONTHLY_4 = 't4'
export const PLAN_PART_MONTHLY_40 = 't40'
export const PLAN_PART_MONTHLY_48 = 't48'
export const PLAN_PART_MONTHLY_56 = 't56'

export function getPlanPart(planId) {
  return planId.split('_')[0]
}

export function isOnetimePlan(planId) {
  return getPlanPart(planId) === PLAN_PART_ONETIME
}

export function isTrialPlan(planId) {
  return getPlanPart(planId) === PLAN_PART_TRIAL
}

export function isMonthlyPlan(planId) {
  const planPart = getPlanPart(planId)
  return planPart !== PLAN_PART_TRIAL && /^t\d+/.exec(planPart) !== null
}

export function isDirectDelivery(planId) {
  const planInfos = planId.split('_')
  return planInfos.length > 1 && planInfos[1] === '1'
}

export function isPickupDeliverySameTime(planId) {
  // plan_idを_で区切って３つ目の値が1なら集配同時
  //（M~LLサイズの集配別は３つ目にサイズ情報が入る）
  const planInfos = planId.split('_')
  return planInfos.length > 2 && planInfos[2] === '1'
}

export function calculatePlanId({
  planPart,
  pickupDeliveryType,
  pickupDeliverySameTime = '',
  bagSizeSuffix = '',
}) {
  // 直接受け渡す以外は不在受け渡しとする
  // 直接受け渡しなら'1'、不在受け渡しなら'2'を返す
  const planIdSuffix = pickupDeliveryType === '1' ? '1' : '2'

  const planIdSuffix2 = pickupDeliverySameTime === '1' ? '_1' : ''

  if (planPart === PLAN_PART_TRIAL) {
    return planPart + '_' + planIdSuffix
  } else if (planPart === PLAN_PART_ONETIME) {
    return planPart + '_' + planIdSuffix
  } else if (planPart === PLAN_PART_MONTHLY_2) {
    return planPart + '_' + planIdSuffix + bagSizeSuffix
  } else {
    return planPart + '_' + planIdSuffix + planIdSuffix2 + bagSizeSuffix
  }
}
